import Vue from 'vue';
import { gsap } from 'gsap';

Vue.component('multi-level-navigation-component', {
    props: ['parents'],

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            currentSublist: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {

    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        openSublist(index) {
            this.currentSublist = index;
            gsap.to('.multi-level-nav__list', 1, { x: '-100%', ease: 'expo.out' });
            gsap.to('.multi-level-nav__sublist-holder', 1, { x: '-100%', ease: 'expo.out', onComplete: this.addSublistClass });
        },

        closeSublist() {
            this.currentSublist = null;
            gsap.to('.multi-level-nav__list', 1, { x: '0%', ease: 'expo.out' });
            gsap.to('.multi-level-nav__sublist-holder', 1, { x: '0%', ease: 'expo.out' });
        },

        addSublistClass() {
            document.querySelector('.multi-level-nav__sublist.show').classList.add('active');
        },
    },
});
